import { ScriptProps } from "next/script";
import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../store/AuthSlice";
import accessToken from "../../utils/access-token"
import Navbar from "./Navbar";
import LoginRegister from "../LoginRegister";
import Confirmation from "../General/Confirmation";
import { useRouter } from "next/router";
import { getCountryList, setHeroSectionVisible } from "../../store/CoreSlice";
import { setSnackBar } from "../../store/ToastSlice";
import Footer from "./Footer";
import ProductSearchDrawer from "../ProductSearchDrawer";
import { setFileData } from "../../store/CoreSlice";
import WhatsAppButton from "../WhatsappButton";

const Main = ({ children }: ScriptProps) => {	
	const router = useRouter();
	const dispatch: any = useDispatch()
	const { heroSectionVisible, isSellerSubdomain, isAdminSubdomain } = useSelector((state: any) => state.core)

	const routes = [
		'/',
		'/platform',
		'/password-reset/[pk]/[token]',
	]

	useEffect(() => {
		const token = accessToken.getAccessToken();
		if (token !== undefined && token !== '' && token) {
			const payload = {
				isLoggedIn: true,
				name: accessToken.getCredentials().user
			}
			dispatch(setUserDetails(payload));
		}
		dispatch(getCountryList({}));

		/**
		 	Since a common state is being managed for the file storing across the platform, 
			clearing of this variable is mandatory at a page change. Else the files will be 
			shown in any other form.
		 */
		router.events.on('routeChangeStart', () => {
			dispatch(setFileData({
				data : [],
				action : 'replace'
			}));
		})

		/* :: Checking if the app is online or offline :: */
		window.addEventListener('online', () => {
			dispatch(setSnackBar({
				message: 'You are back online!',
				color: 'success',
				timeOut: 10000
			}));
		})

		window.addEventListener('offline', () => {
			dispatch(setSnackBar({
				message: 'You are offline!',
				color: 'error',
				timeOut: -1
			}))
		});
	}, [])


	const intersectionOptions = useMemo(() => {
		return {
			root: null,
			rootMargin: '0px',
			threshold: 0
		}
	}, []);

	useEffect(() => {
		const heroSection = document.getElementById('hero-section');
		const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);
		if (heroSection)
			observer.observe(heroSection);

		return () => {
			if (heroSection)
				observer.unobserve(heroSection);
		}
	}, [router.pathname])

	const intersectionCallback = (entries: any) => {
		entries.forEach((entry: any) => {
			dispatch(setHeroSectionVisible(entry.isIntersecting));
		})
	}

	const getNavBarAccordingToCodition = () => {
		if(router.pathname != '/') {			
			return (
				<div
					style={{ transition: 'all 0.8s' }}
					className={`
							z-[99] 
							w-full 
							${routes.includes(router.pathname) ? 'fixed -top-[100px]' : 'sticky top-0'} 
							${!heroSectionVisible && 'top-[0px]'}`
					}
				>
					<Navbar />
				</div>
			)
		}
		else if(router.pathname == '/' && !isSellerSubdomain && !isAdminSubdomain) {
			return (
				<div
					style={{ transition: 'all 0.8s' }}
					className={`
							z-[99] 
							w-full 
							${routes.includes(router.pathname) ? 'fixed -top-[100px]' : 'sticky top-0'} 
							${!heroSectionVisible && 'top-[0px]'}`
					}
				>
					<Navbar />
				</div>
			)
		}
		else	
			return null;
	}

	const getFooterAccordingToCondition = () => {
		if(isAdminSubdomain) {			
			return null;
		}
		else {
			return (
				<div id='footer-section'>
					<Footer />
				</div>
			)
		}
	}
	
	return (
		<div className="league-spartan-font">
			{ getNavBarAccordingToCodition() }
			<LoginRegister />
			<ProductSearchDrawer />
			{children}
			{ getFooterAccordingToCondition() }
			<Confirmation />
			{
				process.env.NEXT_PUBLIC_USE_WHATSAPP === 'true' &&
				<div className="fixed bottom-[10px] right-[10px] z-[100] lg:bottom-[20px] lg:right-[20px]">
					<WhatsAppButton />
				</div>
			}
		</div>
	);
};
export default Main;